












































































































































































const isElement = (x: any): x is HTMLInputElement =>
  x instanceof HTMLInputElement

import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { CookieHelper } from "@/helper/cookieHelper"
import { DateHelper } from "@/helper/dateHelper"

import { ProfileData } from "@/utilityModels/profileData";
import CheckBoxOn from "../../resources/checkBoxOn.vue";
import { ResourceHelper } from '@/helper/resourceHelper';

@Component({
  components: {
    CheckBoxOn
  }
})
export default class Profile extends Vue
{
    profile = {
        name : "",
        phonetic : "",
        nameEnglish : "",
        cellPhoneNumber : "",
        mail : "",
        belongs : "",
        postCode : "",
        phoneNumber : "",
        fax : "",
        address1 : "",
        address2 : "",
        url : ""
    }

    private isProfileAppliedAutomatically : boolean = false;

    mounted(){

        let profile = CookieHelper.getItem("profile")
        
        if(profile){
            this.profile = profile
        }

        // 自動反映する
        if(CookieHelper.hasItem("isProfileAppliedAutomatically"))
        {
            this.isProfileAppliedAutomatically = CookieHelper.getItem("isProfileAppliedAutomatically");
        }
    }

    putFocus(type){

        let element = this.$refs[type] as HTMLInputElement
        element.focus()

    }

    saveCookie(){

        CookieHelper.setItem("profile" , this.profile )
        CookieHelper.setItem("isProfileAppliedAutomatically", this.isProfileAppliedAutomatically);
    }

    private onOk() {
        this.saveCookie()
        this.$emit("close");
    }

    private onClickApplyAuto()
    {
        // 自動反映ON/OFF切り替え
        this.isProfileAppliedAutomatically = !this.isProfileAppliedAutomatically;
    }

    //configcolor
    private get userConfigColors(){
        return this.$store.getters.userConfigColors;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        }
    }
    private get underLineColor(){
      return {
            "border-bottom" : "solid 1px" + this.userConfigColors.buttonColorCode
      }
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }

}
